import { applyAnimations } from '@studio/program';
import { BROADCAST_SET_PROGRAM } from 'actions/Types';

/**
 * This does not make an API call to update program on backend. Make use of
 * this when the expectation is to update program via the realtime
 * connector alone.
 * @param scene object the scene to set the program to
 */
export default scene => {
  return (dispatch, getState) => {
    const { program, overlays, backgrounds } = getState();
    const action = {
      type: BROADCAST_SET_PROGRAM,
      payload: applyAnimations(program, scene),
      sceneLayerSources: { overlays, backgrounds }
    };
    dispatch(action);
  };
};
